import { NODE_ID_ALPHABET_PATTERN } from '../../UIJsonParser/transformations';
export var mapBlockToRuleFrameProps = function (renderBlock) {
    return {
        isLastBlock: renderBlock.isLastBlock,
        isExpanded: renderBlock.uiBlock.isExpanded,
        headerProps: renderBlock,
    };
};
function getNextChar(prevChar) {
    if (!prevChar)
        return 'a';
    return String.fromCharCode(((prevChar.charCodeAt(0) - 97 + 1) % 26) + 97);
}
// will only work up to 26 selections :eyes:
// don't stress test this pls
export var generateSubPredicateIndex = function (uiBlocks, bias) {
    var _a;
    var lastBlock = uiBlocks[length - 1];
    var currentSubIndex = (_a = lastBlock === null || lastBlock === void 0 ? void 0 : lastBlock.nodeId.match(NODE_ID_ALPHABET_PATTERN)) === null || _a === void 0 ? void 0 : _a[0];
    currentSubIndex = getNextChar(currentSubIndex);
    // used to throw if 26 loops so we don't get the infinite weoweo
    var count = 0;
    while (uiBlocks.find(function (block) { return block.nodeId === "".concat(bias).concat(currentSubIndex); })) {
        if (count > 26)
            throw 'Out of subindices!';
        currentSubIndex = getNextChar(currentSubIndex);
        count++;
    }
    return "".concat(bias).concat(currentSubIndex);
};
//# sourceMappingURL=helpers.js.map